import type { Pro20User } from '@/features/auth/types/auth.types';

/** Normalizes user data from localStorage (supports legacy admin-panel shape) */
export function normalizePersistedUser(raw: unknown): Pro20User | null {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const record = raw as Record<string, unknown>;

  const legacyFirst = record.firstName;
  const legacyLast = record.lastName;
  const legacyName =
    typeof legacyFirst === 'string'
      ? `${legacyFirst}${typeof legacyLast === 'string' ? ` ${legacyLast}` : ''}`.trim()
      : '';

  const name =
    typeof record.name === 'string' && record.name.trim()
      ? record.name.trim()
      : legacyName || undefined;

  const userCode = typeof record.userCode === 'string' ? record.userCode : '';
  const jwtToken =
    typeof record.jwtToken === 'string'
      ? record.jwtToken
      : typeof record.accessToken === 'string'
        ? record.accessToken
        : '';

  if (!jwtToken && !userCode && !name) {
    return null;
  }

  return {
    id: typeof record.id === 'number' ? record.id : 0,
    name: name || userCode || 'User',
    phone: typeof record.phone === 'string' ? record.phone : '',
    email: typeof record.email === 'string' ? record.email : '',
    userCode,
    avatar:
      typeof record.avatar === 'string'
        ? record.avatar
        : typeof record.avatarUrl === 'string'
          ? record.avatarUrl
          : null,
    status: typeof record.status === 'string' ? record.status : 'OFFLINE',
    signInMethod:
      typeof record.signInMethod === 'string'
        ? record.signInMethod
        : 'PASSWORD',
    fcmToken: typeof record.fcmToken === 'string' ? record.fcmToken : null,
    jwtToken,
    branches: Array.isArray(record.branches)
      ? (record.branches as Pro20User['branches'])
      : undefined,
    branchCode:
      typeof record.branchCode === 'string' ? record.branchCode : undefined,
  };
}
